import NavbarDashboard from "../../components/navbarDashboard/NavbarDashboard";
import AdminDepCard from "../../components/AdminDepCard/AdminDepCard";
import * as React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { saveAs } from "file-saver";
import { Select, MenuItem, Button, Stack } from "@mui/material";

export default function AdminEditPage() {
  const { currentYear, currentQuarter } = useParams();

  const [allDepts, setAllDepts] = React.useState([]);
  const [selectedDept, setSelectedDept] = React.useState("");

  // ✅ Fetch departments
  React.useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/admin/report/${currentYear}/${currentQuarter}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          }
        );

        const data = await response.json();

        // ✅ CRASH FIX: always guarantee an array
        const depts = Array.isArray(data) ? data : [];
        setAllDepts(depts);

        if (depts.length > 0) {
          setSelectedDept(depts[0].id);
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
        setAllDepts([]); // ✅ prevent n.map crash
      }
    };

    fetchDepartments();
  }, [currentYear, currentQuarter]);

  // ✅ Download handler
  const handleDownload = async () => {
    if (!selectedDept) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/admin/department/${selectedDept}/report/${currentYear}/${currentQuarter}/download`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        }
      );

      const blob = new Blob([response.data], { type: "application/zip" });
      saveAs(blob, `${selectedDept}_report_${currentYear}_${currentQuarter}.zip`);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  // ✅ Per-department deadline extend (used by AdminDepCard calendar)
  const handleSubmit = (selectedDate, id) => {
    const date = selectedDate.$d.toISOString().slice(0, -5) + "Z";

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/admin/deparment/${id}/extend`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        body: JSON.stringify({ deadline: date }),
      }
    )
      .then(() => console.log("Department deadline extended"))
      .catch((error) => console.error(error));
  };

  return (
    <>
      <NavbarDashboard />

      <div style={{ marginTop: "10%", padding: "0 5%" }}>

        {/* DOWNLOAD SECTION */}
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ marginBottom: "30px" }}
        >
          <Select
            value={selectedDept}
            onChange={(e) => setSelectedDept(e.target.value)}
            sx={{ backgroundColor: "#fff", minWidth: 200 }}
          >
            {allDepts.map((dept) => (
              <MenuItem key={dept.id} value={dept.id}>
                {dept.id}
              </MenuItem>
            ))}
          </Select>

          <Button
            variant="contained"
            onClick={handleDownload}
            sx={{
              backgroundColor: "#067094",
              "&:hover": { backgroundColor: "#14475D" },
            }}
          >
            Download Report
          </Button>
        </Stack>

        {/* DEPARTMENT CARDS GRID */}
        <div className="grid-container">
          {allDepts.map((card, index) => (
            <AdminDepCard
              key={index}
              title={card.id}
              content={
                card.reports[0]?.stage === "ACTION_COMPLETED"
                  ? "Completed"
                  : "In Progress"
              }
              onSubmit={handleSubmit}
            />
          ))}
        </div>

      </div>
    </>
  );
}